import { Mail } from 'lucide-react';
import { ArrowIcon, ButtonLink } from '@/components/ui/Button';
import { CatalogueButtons } from '@/components/ui/CatalogueButtons';
import { photoSrc, PHOTOS } from '@/features/site/media';
import { useSite } from '@/features/site/SiteProvider';

/** Section G — high-impact closing call to action, leading to the quote form below. */
export function ClosingCta() {
  const { contact } = useSite().settings;
  const email = contact.emails[0]?.email;

  return (
    <section aria-labelledby="closing-cta-title" className="relative isolate overflow-hidden bg-primary-dark text-white">
      <div
        aria-hidden
        className="absolute inset-0 -z-10 bg-cover bg-center opacity-60"
        style={{ backgroundImage: `url(${photoSrc(PHOTOS.fabricTexture)})` }}
      />
      <div aria-hidden className="absolute inset-0 -z-10 bg-gradient-to-r from-primary-dark via-primary-dark/90 to-primary/80" />

      <div className="container-page grid gap-10 py-20 lg:grid-cols-12 lg:items-end lg:py-28">
        <div className="lg:col-span-8">
          <p className="eyebrow flex items-center gap-3 text-steel">
            <span aria-hidden className="h-px w-8 bg-accent" />
            Start your production
          </p>
          <h2 id="closing-cta-title" className="display-xl mt-5 max-w-[820px]">
            Let&apos;s Build Something <span className="editorial-italic text-accent-soft">for Your Brand.</span>
          </h2>
          <p className="mt-6 max-w-[560px] text-[17px] leading-[1.7] text-steel">
            Share your product, quantities and branding requirements. Our team replies with feasibility, MOQ and a written quotation.
          </p>
        </div>
        <div className="flex flex-col gap-4 lg:col-span-4 lg:items-end">
          <ButtonLink to="#inquiry" variant="accent" size="lg" icon={<ArrowIcon />}>
            Request a Manufacturing Quote
          </ButtonLink>
          <CatalogueButtons inverted size="md" />
          {email && (
            <a href={`mailto:${email}`} className="inline-flex items-center gap-2 text-[14px] text-steel transition-colors hover:text-white">
              <Mail className="h-4 w-4" aria-hidden />
              or email {email}
            </a>
          )}
        </div>
      </div>
    </section>
  );
}
